import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";
import './UserTransfer.css';

const API_BASE_URL = 'https://dmarepositoryportal.in';

const UserTransfer = () => {
    const [abcSubmissions, setAbcSubmissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [serverStatus, setServerStatus] = useState('checking');
    const [selectedSubmission, setSelectedSubmission] = useState(null);
    const [selectedFormDData, setSelectedFormDData] = useState(null);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('formA');
    const [loadingFormD, setLoadingFormD] = useState(false);
    
    // Sidebar state
    const [sbCollapsed, setSbCollapsed] = useState(false);
    const [mobileView, setMobileView] = useState(window.innerWidth <= 768);
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('english');
    
    // Filter states
    const [filters, setFilters] = useState({
        search: ''
    });
    
    const [downloadingFile, setDownloadingFile] = useState(null);
    const [messageState, setMessageState] = useState({ text: '', type: '' });

    const axiosInstance = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: { 'Content-Type': 'application/json' }
    });

    axiosInstance.interceptors.response.use(
        response => response,
        error => {
            console.error('Axios Error:', error);
            throw error;
        }
    );

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setMobileView(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setShowMobileSidebar(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Language detection
    useEffect(() => {
        const checkLanguage = () => {
            const savedLanguage = sessionStorage.getItem("dma_portal_language");
            if (savedLanguage === "MR") {
                setSelectedLanguage("marathi");
            } else {
                setSelectedLanguage("english");
            }
        };
        checkLanguage();
        const interval = setInterval(checkLanguage, 500);
        return () => clearInterval(interval);
    }, []);

    const showMessage = (text, type = 'success') => {
        setMessageState({ text, type });
        setTimeout(() => setMessageState({ text: '', type: '' }), 3000);
    };

    const checkServerHealth = async () => {
        try {
            const response = await axiosInstance.get('/formabc/health-check', { timeout: 5000 });
            if (response.data.success && response.data.status === 'healthy') {
                setServerStatus('connected');
                setError('');
                return true;
            } else {
                setServerStatus('disconnected');
                setError('Server is not responding properly');
                return false;
            }
        } catch (error) {
            console.error('Health check failed:', error);
            setServerStatus('disconnected');
            setError(`Cannot connect to server at ${API_BASE_URL}`);
            return false;
        }
    };

    // Calculate form filling percentage
    const calculateFormFillingPercentage = (submission) => {
        let totalForms = 4; // Form A, B, C, D
        let filledForms = 0;
        
        if (submission.form_a_submitted) filledForms++;
        if (submission.form_b_submitted) filledForms++;
        if (submission.form_c_submitted) filledForms++;
        
        return Math.round((filledForms / totalForms) * 100);
    };

    // Get form filling status text
    const getFormFillingStatus = (percentage) => {
        if (percentage === 100) return { text: 'Complete', color: '#52c41a', icon: '✅' };
        if (percentage >= 75) return { text: 'Advanced', color: '#1890ff', icon: '📝' };
        if (percentage >= 50) return { text: 'Half', color: '#faad14', icon: '⏳' };
        if (percentage >= 25) return { text: 'Partial', color: '#fa8c16', icon: '⚠️' };
        return { text: 'Not Started', color: '#ff4d4f', icon: '❌' };
    };

    // Get all ABC submissions
   // Get all ABC submissions - FIXED to fetch all records
const getABCSubmissions = async () => {
    if (serverStatus !== 'connected') {
        const isConnected = await checkServerHealth();
        if (!isConnected) return;
    }

    setLoading(true);
    setError('');
    try {
        // Use fetch_all=true to get all records without pagination
        const response = await axiosInstance.get('/formabc/all-submissions', { 
            params: { fetch_all: true },  // Add this to get all records
            timeout: 30000 
        });
        
        if (response.data.success) {
            let submissions = (response.data.data || []).map(sub => {
                if (sub.form_c_ulb_entries && typeof sub.form_c_ulb_entries === 'string') {
                    try {
                        sub.ulb_entries = JSON.parse(sub.form_c_ulb_entries);
                    } catch (e) {
                        sub.ulb_entries = [];
                    }
                } else if (sub.form_c_ulb_entries) {
                    sub.ulb_entries = sub.form_c_ulb_entries;
                } else {
                    sub.ulb_entries = [];
                }
                return sub;
            });
            
            // Apply search filter
            if (filters.search) {
                const searchLower = filters.search.toLowerCase();
                submissions = submissions.filter(sub => {
                    const nameMatch = (sub.employee_name_english || '').toLowerCase().includes(searchLower);
                    const nameMarathiMatch = (sub.employee_name_marathi || '').toLowerCase().includes(searchLower);
                    const desigMatch = (sub.current_designation || '').toLowerCase().includes(searchLower);
                    return nameMatch || nameMarathiMatch || desigMatch;
                });
            }
            
            setAbcSubmissions(submissions);
            showMessage(`✅ Loaded ${submissions.length} records`, 'success');
        } else {
            setError(response.data.message || 'Failed to fetch submissions');
        }
    } catch (err) {
        console.error('Error fetching submissions:', err);
        setError(err.message || 'Failed to fetch submissions');
    } finally {
        setLoading(false);
    }
};

    // Fetch Form D data for a specific user
    const fetchFormDData = async (userId) => {
        if (!userId) return null;
        
        setLoadingFormD(true);
        try {
            const response = await axiosInstance.get(`/formd/form-data?user_id=${userId}`, { timeout: 10000 });
            if (response.data.success && response.data.data) {
                let formDData = response.data.data;
                if (formDData.preferences && typeof formDData.preferences === 'string') {
                    try {
                        formDData.preferences = JSON.parse(formDData.preferences);
                    } catch (e) {
                        formDData.preferences = [];
                    }
                }
                return formDData;
            }
            return null;
        } catch (err) {
            console.log('No Form D data found for user:', userId);
            return null;
        } finally {
            setLoadingFormD(false);
        }
    };

    const handleViewDetails = async (submissionId, userId) => {
        if (serverStatus !== 'connected') {
            setError('Server not connected. Please refresh the page.');
            return;
        }

        setLoading(true);
        try {
            // Fetch ABC submission details
            const response = await axiosInstance.get(`/formabc/submission/${submissionId}`, { timeout: 10000 });
            
            if (response.data.success) {
                const abcData = response.data.data;
                if (abcData.form_c_ulb_entries && typeof abcData.form_c_ulb_entries === 'string') {
                    try {
                        abcData.ulb_entries = JSON.parse(abcData.form_c_ulb_entries);
                    } catch (e) {
                        abcData.ulb_entries = [];
                    }
                } else if (abcData.form_c_ulb_entries) {
                    abcData.ulb_entries = abcData.form_c_ulb_entries;
                } else {
                    abcData.ulb_entries = [];
                }
                
                setSelectedSubmission(abcData);
                
                // Fetch Form D data for the same user
                const formDData = await fetchFormDData(userId || abcData.user_id);
                setSelectedFormDData(formDData);
                
                setDetailsOpen(true);
                setActiveTab('formA');
            } else {
                setError(response.data.message || 'Failed to fetch submission details');
            }
        } catch (err) {
            console.error('Error fetching details:', err);
            setError(err.message || 'Failed to fetch submission details');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        try {
            return new Date(dateString).toLocaleDateString('en-IN');
        } catch {
            return dateString;
        }
    };

    const isEmpty = (value) => {
        if (value === null || value === undefined) return true;
        if (value === '') return true;
        if (value === 'null') return true;
        if (value === 'undefined') return true;
        if (typeof value === 'string' && value.trim() === '') return true;
        return false;
    };

    const renderValue = (value) => {
        if (isEmpty(value)) {
            return <span className="null-value">-</span>;
        }
        return value;
    };

    const handleFileDownload = async (fileUrl, fileName) => {
        if (!fileUrl) return;
        
        setDownloadingFile(fileName);
        try {
            let url = fileUrl;
            if (url.startsWith('http://http://')) {
                url = url.replace('http://http://', 'http://');
            }
            if (url.startsWith('https://dmarepositoryportal.inhttp://')) {
                url = url.replace('https://dmarepositoryportal.inhttp://', 'http://');
            }
            if (!url.startsWith('http')) {
                url = `${API_BASE_URL}${url}`;
            }
            
            const response = await fetch(url);
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            showMessage(`✓ ${fileName} downloaded successfully!`, 'success');
        } catch (error) {
            console.error('Error downloading file:', error);
            window.open(fileUrl, '_blank');
            showMessage('Opening file in new tab...', 'info');
        } finally {
            setTimeout(() => setDownloadingFile(null), 1000);
        }
    };

    const renderFileLink = (url, label = 'View File') => {
        if (isEmpty(url)) return '-';
        const isDownloading = downloadingFile === label;
        return (
            <button 
                onClick={() => handleFileDownload(url, label)}
                className="file-link-btn"
                disabled={isDownloading}
            >
                {isDownloading ? '⏳ Downloading...' : `📥 ${label}`}
            </button>
        );
    };

    const buildUlbHistory = (submission) => {
        const history = [];
        const ulbEntries = submission.ulb_entries || [];
        
        ulbEntries.forEach((entry, idx) => {
            history.push({
                divisional_office: entry.divisional_office,
                district: entry.district,
                ulb_name: entry.ulb_name,
                service_from: entry.service_from,
                service_to: entry.service_to,
                remarks: entry.remarks
            });
        });
        return history;
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
    };

    const handleClearFilters = () => {
        setFilters({ search: '' });
        setTimeout(() => {
            getABCSubmissions();
        }, 100);
    };

    const handleRefresh = () => {
        getABCSubmissions();
    };

    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toLocaleDateString();
        const time = now.toLocaleTimeString();
        return { date, time };
    };

    // Initial server check
    useEffect(() => {
        checkServerHealth();
    }, []);

    useEffect(() => {
        if (serverStatus === 'connected') {
            getABCSubmissions();
        }
    }, [serverStatus, filters.search]);

    const getPriorityCategoryName = (category) => {
        const categories = {
            1: 'Self Disability',
            2: 'Dependent Disability',
            3: 'Self Serious Illness',
            4: 'Widow/Divorced',
            5: 'Spouse Working Together',
            6: 'Family Member Illness',
            7: 'Ex-Serviceman',
            8: 'General Transfer Request'
        };
        return categories[category] || '-';
    };

    // ==================== RENDER FORM A DETAILS ====================
    const renderFormADetails = (submission) => (
        <div className="detail-section">
            <h3>📝 Form A - Personal & Employment Information</h3>
            <div className={`form-status-header ${submission.form_a_submitted ? 'submitted' : 'pending'}`}>
                {submission.form_a_submitted ? '✓ Form A Submitted' : '⏳ Form A Not Submitted Yet'}
            </div>
            
            <h4>👤 Personal Information</h4>
            <div className="detail-grid">
                {/* <div><strong>Submission ID:</strong> {renderValue(submission.submission_id)}</div> */}
                {/* <div><strong>User ID:</strong> {renderValue(submission.user_id)}</div> */}
                <div><strong>Name (English):</strong> {renderValue(submission.employee_name_english)}</div>
                <div><strong>Name (Marathi):</strong> {renderValue(submission.employee_name_marathi)}</div>
                <div><strong>Gender:</strong> {renderValue(submission.gender)}</div>
                <div><strong>Marital Status:</strong> {renderValue(submission.marital_status)}</div>
                {submission.married_name_marathi && <div><strong>Married Name (Marathi):</strong> {renderValue(submission.married_name_marathi)}</div>}
                {submission.married_name_english && <div><strong>Married Name (English):</strong> {renderValue(submission.married_name_english)}</div>}
                <div><strong>Birth Date:</strong> {formatDate(submission.birth_date)}</div>
                {/* <div><strong>Religion:</strong> {renderValue(submission.religion)}</div> */}
                {/* <div><strong>Caste:</strong> {renderValue(submission.caste)}</div> */}
                <div><strong>Native Place:</strong> {renderValue(submission.native_place)}</div>
            </div>
            
            <h4>💼 Employment Information</h4>
            <div className="detail-grid">
                <div><strong>Current Designation:</strong> {renderValue(submission.current_designation)}</div>
                <div><strong>Current Category:</strong> {renderValue(submission.current_category)}</div>
                {/* <div><strong>Education at Appointment:</strong> {renderValue(submission.education_at_appointment)}</div> */}
                {/* <div><strong>Current Education:</strong> {renderValue(submission.current_education)}</div> */}
                <div><strong>Seniority Number 2022:</strong> {renderValue(submission.seniority_number_2022)}</div>
                <div><strong>Retirement Date:</strong> {formatDate(submission.retirement_date)}</div>
                {/* <div><strong>Departmental Exam Passed:</strong> {renderValue(submission.departmental_exam_passed)}</div> */}
            </div>
            
            {/* <h4>📍 Address Information</h4>
            <div className="detail-grid">
                <div><strong>Current Address:</strong> {renderValue(submission.current_address)}</div>
                <div><strong>Current Pincode:</strong> {renderValue(submission.current_pincode)}</div>
                <div><strong>Permanent Division:</strong> {renderValue(submission.permanent_division)}</div>
                <div><strong>Permanent District:</strong> {renderValue(submission.permanent_district)}</div>
                <div><strong>Permanent Address:</strong> {renderValue(submission.permanent_address)}</div>
                <div><strong>Permanent Pincode:</strong> {renderValue(submission.permanent_pincode)}</div>
                <div><strong>Hometown ULB:</strong> {renderValue(submission.hometown_ulb)}</div>
                <div><strong>Is Permanent Same as ULB:</strong> {renderValue(submission.is_permanent_same_as_ulb)}</div>
            </div> */}
            
            <h4>📜 Declaration</h4>
            <div className="detail-grid">
                <div><strong>Declaration:</strong> {submission.declaration ? '✓ Accepted' : '✗ Not Accepted'}</div>
                {/* <div><strong>Chief Officer Remark:</strong> {renderValue(submission.chief_officer_remark)}</div> */}
                <div><strong>Submitted By:</strong> {renderValue(submission.submitted_by)}</div>
                <div><strong>Submission Date:</strong> {formatDate(submission.submission_date)}</div>
            </div>
        </div>
    );

    // ==================== RENDER FORM B DETAILS ====================
    const renderFormBDetails = (submission) => (
        <div className="detail-section">
            <h3>📄 Form B - Appointment Information</h3>
            <div className={`form-status-header ${submission.form_b_submitted ? 'submitted' : 'pending'}`}>
                {submission.form_b_submitted ? '✓ Form B Submitted' : '⏳ Form B Not Submitted Yet'}
            </div>
            
            <h4>📅 First Appointment Details</h4>
            <div className="detail-grid">
                <div><strong>First Appointment Designation:</strong> {renderValue(submission.first_appointment_designation)}</div>
                <div><strong>First Appointment Category:</strong> {renderValue(submission.first_appointment_category)}</div>
                <div><strong>Appointment Type:</strong> {renderValue(submission.appointment_type)}</div>
                {/* <div><strong>Appointment Date (Inclusion):</strong> {formatDate(submission.appointment_date_inclusion)}</div> */}
                {/* <div><strong>Appointing Authority:</strong> {renderValue(submission.appointing_authority_designation_inclusion)}</div> */}
                {/* {submission.appointment_order_inclusion && (
                    <div><strong>Appointment Order:</strong> {renderFileLink(submission.appointment_order_inclusion, 'Appointment Order')}</div>
                )} */}
                {/* <div><strong>Appointment Order Date:</strong> {formatDate(submission.appointment_order_date_inclusion)}</div> */}
            </div>
            
            {/* <h4>🏢 Original ULB Details</h4>
            <div className="detail-grid">
                <div><strong>Divisional Office:</strong> {renderValue(submission.divisional_office)}</div>
                <div><strong>Original ULB District:</strong> {renderValue(submission.original_ulb_district_inclusion)}</div>
                <div><strong>Original ULB Name:</strong> {renderValue(submission.original_ulb_name_inclusion)}</div>
                {submission.original_ulb_order && (
                    <div><strong>Original ULB Order:</strong> {renderFileLink(submission.original_ulb_order, 'Original ULB Order')}</div>
                )}
                <div><strong>Original ULB Duration From:</strong> {formatDate(submission.original_ulb_duration_from)}</div>
                <div><strong>Original ULB Duration To:</strong> {formatDate(submission.original_ulb_duration_to)}</div>
            </div> */}
            
            {/* <h4>📋 Direct Appointment Details</h4>
            <div className="detail-grid">
                <div><strong>Appointment Date (Direct):</strong> {formatDate(submission.appointment_date_direct)}</div>
                <div><strong>Appointing Authority:</strong> {renderValue(submission.appointing_authority_designation_direct)}</div>
                {submission.appointment_order_direct && (
                    <div><strong>Appointment Order (Direct):</strong> {renderFileLink(submission.appointment_order_direct, 'Direct Appointment Order')}</div>
                )}
            </div> */}
            
            {/* <h4>🏷️ Caste & Reservation Details</h4>
            <div className="detail-grid">
                <div><strong>Caste Category:</strong> {renderValue(submission.caste_category)}</div>
                {submission.caste_certificate && (
                    <div><strong>Caste Certificate:</strong> {renderFileLink(submission.caste_certificate, 'Caste Certificate')}</div>
                )}
                {submission.caste_validity_certificate && (
                    <div><strong>Caste Validity Certificate:</strong> {renderFileLink(submission.caste_validity_certificate, 'Caste Validity Certificate')}</div>
                )}
                <div><strong>Parallel Reservation:</strong> {renderValue(submission.parallel_reservation)}</div>
            </div> */}
            
                {/* <h4>📈 Promotion Details</h4>
                <div className="detail-grid">
                    <div><strong>Has Promotion:</strong> {renderValue(submission.has_promotion)}</div>
                    {submission.promotion_designation && <div><strong>Promotion Designation:</strong> {renderValue(submission.promotion_designation)}</div>}
                    {submission.promotion_category && <div><strong>Promotion Category:</strong> {renderValue(submission.promotion_category)}</div>}
                    {submission.promotion_date && <div><strong>Promotion Date:</strong> {formatDate(submission.promotion_date)}</div>}
                    {submission.promotion_order && (
                        <div><strong>Promotion Order:</strong> {renderFileLink(submission.promotion_order, 'Promotion Order')}</div>
                    )}
                </div> */}
        </div>
    );

    // ==================== RENDER FORM C DETAILS ====================
    const renderFormCDetails = (submission) => (
        <div className="detail-section">
            <h3>📋 Form C - ULB History</h3>
            <div className={`form-status-header ${submission.form_c_submitted ? 'submitted' : 'pending'}`}>
                {submission.form_c_submitted ? '✓ Form C Submitted' : '⏳ Form C Not Submitted Yet'}
            </div>
            
            <h4>🏢 ULB Service History ({submission.ulb_count || 0} ULBs)</h4>
            {(() => {
                const ulbHistory = buildUlbHistory(submission);
                if (ulbHistory.length === 0) return <p>No ULB history available</p>;
                return (
                    <div className="table-responsive">
                        <table className="detail-table">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Division</th>
                                    <th>District</th>
                                    <th>ULB Name</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Remarks</th>
                                  </tr>
                            </thead>
                            <tbody>
                                {ulbHistory.map((ulb, idx) => (
                                    <tr key={idx}>
                                        <td>{idx + 1}</td>
                                        <td>{renderValue(ulb.divisional_office)}</td>
                                        <td>{renderValue(ulb.district)}</td>
                                        <td><strong>{renderValue(ulb.ulb_name)}</strong></td>
                                        <td>{renderValue(ulb.service_from)}</td>
                                        <td>{renderValue(ulb.service_to)}</td>
                                        <td>{renderValue(ulb.remarks)}</td>
                                      </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            })()}
        </div>
    );

    // ==================== RENDER FORM D DETAILS ====================
    const renderFormDDetails = (formDData) => {
        if (!formDData) {
            return (
                <div className="detail-section">
                    <h3>📋 Form D - Transfer Request</h3>
                    <div className="form-status-header pending">
                        ⏳ Form D Not Submitted Yet
                    </div>
                    <p>No Form D data found for this user.</p>
                </div>
            );
        }

        return (
            <div className="detail-section">
                <h3>📋 Form D - Transfer Request</h3>
                <div className={`form-status-header ${formDData.form_d_submitted ? 'submitted' : 'pending'}`}>
                    {formDData.form_d_submitted ? '✓ Form D Submitted' : '⏳ Form D Not Submitted Yet'}
                </div>
                
                <h4>🏢 Basic Information</h4>
                <div className="detail-grid">
                    <div><strong>Submission ID:</strong> {renderValue(formDData.submission_id)}</div>
                    <div><strong>Division:</strong> {renderValue(formDData.division_name)}</div>
                    <div><strong>District:</strong> {renderValue(formDData.district_name)}</div>
                    <div><strong>Current ULB:</strong> {renderValue(formDData.ulb_name)}</div>
                    <div><strong>ULB Type:</strong> {formDData.ulb_hard_status === 1 ? 'Hard Area' : 'Non-Hard Area'}</div>
                    <div><strong>Has Project:</strong> {formDData.ulb_has_project ? 'Yes' : 'No'}</div>
                    <div><strong>Retiring within one year:</strong> {formDData.retiring_within_one_year ? 'Yes' : 'No'}</div>
                    <div><strong>Eligible for Extension:</strong> {formDData.eligible_for_extension ? 'Yes' : 'No'}</div>
                    {formDData.extension_reason && <div><strong>Extension Reason:</strong> {renderValue(formDData.extension_reason)}</div>}
                </div>
                
                <h4>⭐ Priority Category</h4>
                <div className="detail-grid">
                    <div><strong>Selected Priority:</strong> <strong style={{color: '#1890ff'}}>{getPriorityCategoryName(formDData.priority_category)}</strong></div>
                </div>
                
                {formDData.priority_category === 1 && (
                    <>
                        <h4>👤 Self Disability Details</h4>
                        <div className="detail-grid">
                            <div><strong>Disability Type:</strong> {renderValue(formDData.disability_type)}</div>
                            <div><strong>Disability Percentage:</strong> {renderValue(formDData.disability_percentage)}%</div>
                            <div><strong>Authority Name:</strong> {renderValue(formDData.disability_authority_name)}</div>
                            <div><strong>Certificate No:</strong> {renderValue(formDData.disability_certificate_no)}</div>
                            <div><strong>Certificate Date:</strong> {formatDate(formDData.disability_certificate_date)}</div>
                            <div><strong>Certificate:</strong> {renderFileLink(formDData.disability_certificate_file, 'Disability Certificate')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 2 && (
                    <>
                        <h4>👨‍👩‍👧 Dependent Disability Details</h4>
                        <div className="detail-grid">
                            <div><strong>Relationship:</strong> {renderValue(formDData.dependent_relationship)}</div>
                            <div><strong>Dependent Name:</strong> {renderValue(formDData.dependent_name)}</div>
                            <div><strong>Disability Type:</strong> {renderValue(formDData.dependent_disability_type)}</div>
                            <div><strong>Certificate:</strong> {renderFileLink(formDData.dependent_certificate_file, 'Dependent Disability Certificate')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 3 && (
                    <>
                        <h4>🏥 Self Illness Details</h4>
                        <div className="detail-grid">
                            <div><strong>Illness Type:</strong> {renderValue(formDData.illness_type)}</div>
                            <div><strong>Authority Name:</strong> {renderValue(formDData.illness_authority_name)}</div>
                            <div><strong>Certificate Date:</strong> {formatDate(formDData.illness_certificate_date)}</div>
                            <div><strong>Medical Certificate:</strong> {renderFileLink(formDData.illness_certificate_file, 'Medical Certificate')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 4 && (
                    <>
                        <h4>💔 Widow/Divorced Details</h4>
                        <div className="detail-grid">
                            <div><strong>Status:</strong> {renderValue(formDData.widow_status)}</div>
                            {formDData.husband_death_certificate && <div><strong>Death Certificate:</strong> {renderFileLink(formDData.husband_death_certificate, 'Death Certificate')}</div>}
                            {formDData.divorce_document && <div><strong>Divorce Document:</strong> {renderFileLink(formDData.divorce_document, 'Divorce Document')}</div>}
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 5 && (
                    <>
                        <h4>💑 Spouse Working Together Details</h4>
                        <div className="detail-grid">
                            <div><strong>Spouse Name:</strong> {renderValue(formDData.spouse_name)}</div>
                            <div><strong>Spouse Office Type:</strong> {renderValue(formDData.spouse_office_type)}</div>
                            <div><strong>Spouse Office Name:</strong> {renderValue(formDData.spouse_office_name)}</div>
                            <div><strong>Spouse Office Location:</strong> {renderValue(formDData.spouse_office_location)}</div>
                            <div><strong>Spouse Certificate:</strong> {renderFileLink(formDData.spouse_certificate, 'Spouse Certificate')}</div>
                            <div><strong>Spouse ID Proof:</strong> {renderFileLink(formDData.spouse_id_proof, 'Spouse ID Proof')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 6 && (
                    <>
                        <h4>👨‍👩‍👧 Family Illness Details</h4>
                        <div className="detail-grid">
                            <div><strong>Relationship:</strong> {renderValue(formDData.family_relationship)}</div>
                            <div><strong>Member Name:</strong> {renderValue(formDData.family_member_name)}</div>
                            <div><strong>Illness Type:</strong> {renderValue(formDData.family_illness_type)}</div>
                            <div><strong>Medical Certificate:</strong> {renderFileLink(formDData.family_medical_certificate, 'Medical Certificate')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 7 && (
                    <>
                        <h4>🎖️ Ex-Serviceman Details</h4>
                        <div className="detail-grid">
                            <div><strong>Document:</strong> {renderFileLink(formDData.ex_serviceman_document, 'Ex-Serviceman Document')}</div>
                        </div>
                    </>
                )}
                
                {formDData.priority_category === 8 && (
                    <>
                        <h4>📝 General Transfer Request</h4>
                        <div className="detail-grid">
                            <div><strong>Request Letter:</strong> {renderFileLink(formDData.general_transfer_request, 'Transfer Request Letter')}</div>
                        </div>
                    </>
                )}
                
                <h4>🎯 Transfer Preferences</h4>
                {formDData.preferences && formDData.preferences.length > 0 ? (
                    <div className="table-responsive">
                        <table className="detail-table">
                            <thead>
                                <tr><th>Sr. No.</th><th>Division</th><th>District</th><th>ULB Name</th></tr>
                            </thead>
                            <tbody>
                                {formDData.preferences.map((pref, idx) => (
                                    <tr key={idx}><td>{idx + 1}</td><td>{renderValue(pref.division_name)}</td><td>{renderValue(pref.district_name)}</td><td><strong>{renderValue(pref.ulb_name)}</strong></td></tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : <p>No preferences selected</p>}
                
                <h4>📜 Declaration & Confirmation</h4>
                <div className="detail-grid">
                    <div><strong>Preferences Confirmed:</strong> {formDData.preferences_confirmed ? '✓ Yes' : '✗ No'}</div>
                    <div><strong>Declaration Accepted:</strong> {formDData.declaration ? '✓ Yes' : '✗ No'}</div>
                </div>
                
                <h4>✍️ Signature</h4>
                <div className="detail-grid">
                    <div><strong>Signer Name:</strong> {renderValue(formDData.form_d_signature_name)}</div>
                    <div><strong>Designation:</strong> {renderValue(formDData.form_d_signature_designation)}</div>
                    <div><strong>Signed At:</strong> {formatDate(formDData.form_d_signature_at)}</div>
                    {formDData.form_d_signature && <div><strong>Signature:</strong> {renderFileLink(formDData.form_d_signature, 'View Signature')}</div>}
                    {formDData.form_d_signed_pdf && <div><strong>Signed PDF:</strong> {renderFileLink(formDData.form_d_signed_pdf, 'Download Signed PDF')}</div>}
                </div>
            </div>
        );
    };

    // ==================== RENDER FILES SECTION ====================
    const renderFilesSection = (submission) => (
        <div className="detail-section">
            <h3>📎 Uploaded Files</h3>
            {submission.files && submission.files.length > 0 ? (
                <div className="files-grid">
                    {submission.files.map((file, idx) => (
                        <div key={file.id || idx} className="file-card">
                            <div className="file-icon">
                                {file.mime_type?.includes('pdf') ? '📄' : 
                                 file.mime_type?.includes('image') ? '🖼️' : 
                                 file.mime_type?.includes('word') ? '📝' : 
                                 file.mime_type?.includes('excel') ? '📊' : '📁'}
                            </div>
                            <div className="file-info">
                                <div className="file-name" title={file.original_name}>
                                    {file.original_name?.length > 40 ? file.original_name.substring(0, 40) + '...' : file.original_name}
                                </div>
                                <div className="file-meta">
                                    <span>Form: {file.form_type || 'N/A'}</span>
                                    <span>Field: {file.field_name || 'N/A'}</span>
                                    <span>Size: {(file.file_size / 1024).toFixed(2)} KB</span>
                                </div>
                                <div className="file-actions">
                                    <button onClick={() => handleFileDownload(file.file_url, file.original_name)} className="btn-file-view">
                                        📥 Download
                                    </button>
                                    <a href={file.file_url} target="_blank" rel="noopener noreferrer" className="btn-file-view">
                                        👁️ View
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No files uploaded for this submission</p>
            )}
        </div>
    );

    // Sidebar extra content
    const sidebarExtraContent = (
        <div style={{
            margin: '16px 8px',
            padding: '16px',
            background: 'linear-gradient(135deg, #667eea 0%, #001696cc 100%)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(102, 126, 234, 0.3)',
            color: 'white'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '16px',
                paddingBottom: '12px',
                borderBottom: '2px solid rgba(255,255,255,0.2)'
            }}>
                <span role="img" aria-label="stats" style={{ fontSize: '28px' }}>📊</span>
                <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
                    {selectedLanguage === 'english' ? 'Statistics' : 'आकडेवारी'}
                </span>
            </div>
            
            <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span>{selectedLanguage === 'english' ? 'Total Submissions' : 'एकूण नोंदी'}</span>
                    <span style={{ fontWeight: 'bold' }}>{abcSubmissions.length}</span>
                </div>
            </div>

            <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span>{selectedLanguage === 'english' ? 'Form A Submitted' : 'फॉर्म अ सबमिट'}</span>
                    <span style={{ fontWeight: 'bold' }}>{abcSubmissions.filter(s => s.form_a_submitted).length}</span>
                </div>
            </div>

            <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span>{selectedLanguage === 'english' ? 'Form B Submitted' : 'फॉर्म ब सबमिट'}</span>
                    <span style={{ fontWeight: 'bold' }}>{abcSubmissions.filter(s => s.form_b_submitted).length}</span>
                </div>
            </div>

            <div style={{ marginBottom: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span>{selectedLanguage === 'english' ? 'Form C Submitted' : 'फॉर्म क सबमिट'}</span>
                    <span style={{ fontWeight: 'bold' }}>{abcSubmissions.filter(s => s.form_c_submitted).length}</span>
                </div>
            </div>

            <div style={{
                marginTop: '20px',
                padding: '12px',
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '12px',
                backdropFilter: 'blur(5px)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span role="img" aria-label="clock">🕐</span>
                    <span style={{ fontSize: '13px' }}>{getCurrentDateTime().date} | {getCurrentDateTime().time}</span>
                </div>
            </div>
        </div>
    );

    // Render Sidebar
    const renderSidebar = () => {
        if (mobileView) {
            return (
                <>
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        zIndex: 999,
                        display: showMobileSidebar ? 'block' : 'none'
                    }} onClick={() => setShowMobileSidebar(false)} />
                    
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '250px',
                        backgroundColor: 'white',
                        zIndex: 1000,
                        transform: showMobileSidebar ? 'translateX(0)' : 'translateX(-100%)',
                        transition: 'transform 0.3s ease',
                        boxShadow: '2px 0 10px rgba(0,0,0,0.1)'
                    }}>
                        {/* <Sidebar collapsed={false} setCollapsed={setSbCollapsed} extraContent={sidebarExtraContent} /> */}
                    </div>

                    <button style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        zIndex: 1000,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '50px',
                        height: '50px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #667eea 0%, #001696cc 100%)',
                        color: 'white',
                        border: 'none',
                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                        cursor: 'pointer',
                        fontSize: '20px'
                    }} onClick={() => setShowMobileSidebar(!showMobileSidebar)}>
                        {showMobileSidebar ? '✕' : '☰'}
                    </button>
                </>
            );
        }
    //     return <Sidebar collapsed={sbCollapsed} setCollapsed={setSbCollapsed} extraContent={sidebarExtraContent} />;
    };

    // Render Navbar
    const renderNavbar = () => <Navbar onMenuClick={() => setSbCollapsed(!sbCollapsed)} />;

    // Main content style
    const mainContentStyle = {
        flex: 1,
        padding: '20px',
        marginLeft: mobileView ? '0' : (sbCollapsed ? '50px' : '200px'),
        marginTop: '70px',
        background: '#f5f5f5',
        minHeight: 'calc(100vh - 70px)',
        transition: 'margin-left 0.3s ease',
        width: mobileView ? '100%' : 'auto'
    };

    return (
        <div style={{ fontFamily: 'system-ui, sans-serif' }}>
            {renderNavbar()}
            <div style={{ display: 'flex' }}>
                {renderSidebar()}
                <div style={mainContentStyle}>
                    <div className="user-transfer-container">
                        

                        {serverStatus === 'disconnected' && (
                            <div className="alert alert-error">
                                <strong>⚠️ Cannot connect to server!</strong>
                                <p>Please make sure the backend server is running at: {API_BASE_URL}</p>
                                <button onClick={checkServerHealth} className="btn btn-primary">Retry Connection</button>
                            </div>
                        )}

                        {serverStatus === 'connected' && (
                            <div className="content">
                                {/* Search Filter */}
                                <div className="filters-card">
                                    <h3>🔍 Search</h3>
                                    <div className="filters-grid">
                                        <div className="filter-group full-width">
                                            <label>Search by Name (English/Marathi) or Designation</label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter employee name or designation..." 
                                                value={filters.search} 
                                                onChange={(e) => handleFilterChange('search', e.target.value)} 
                                                className="form-control" 
                                            />
                                        </div>
                                    </div>
                                    <div className="filter-actions">
                                        <button onClick={handleClearFilters} className="btn btn-secondary">Clear</button>
                                        <button onClick={handleRefresh} className="btn btn-primary">Refresh</button>
                                    </div>
                                </div>

                                {loading && (
                                    <div className="loading-container">
                                        <div className="spinner"></div>
                                        <p>Loading submissions...</p>
                                    </div>
                                )}

                                {!loading && (
                                    <div className="table-card">
                                        {abcSubmissions.length === 0 ? (
                                            <div className="empty-state">
                                                <p>No submissions found</p>
                                                <button onClick={handleClearFilters} className="btn btn-primary">Clear Filters</button>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="table-responsive">
                                                    <table className="data-table">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr. No.</th>
                                                                <th>Employee Name</th>
                                                                <th>Class</th>
                                                                <th>Form Filling %</th>
                                                                
                                                                <th>Submission Date</th>
                                                                <th>Action</th>
                                                              </tr>
                                                        </thead>
                                                        <tbody>
                                                            {abcSubmissions.map((row, index) => {
                                                                const percentage = calculateFormFillingPercentage(row);
                                                                const status = getFormFillingStatus(percentage);
                                                                return (
                                                                    <tr key={row.id}>
                                                                        <td>{index + 1}</td>
                                                                        <td>
                                                                            <strong>{renderValue(row.employee_name_english)}</strong>
                                                                            <br/>
                                                                            <small style={{color: '#666'}}>{renderValue(row.employee_name_marathi)}</small>
                                                                            <br/>
                                                                            <small style={{color: '#999'}}>{renderValue(row.current_designation)}</small>
                                                                        </td>
                                                                        {/* <td>{renderValue(row.hometown_ulb)}</td> */}
                                                                        <td>{renderValue(row.current_category)}</td>
                                                                        <td>
                                                                            <div className="progress-container">
                                                                                <div className="progress-bar" style={{width: `${percentage}%`, backgroundColor: status.color}}></div>
                                                                                <span className="progress-text">{percentage}%</span>
                                                                            </div>
                                                                        </td>
                                                                        {/* <td> */}
                                                                            {/* <span style={{color: status.color, fontWeight: 'bold'}}>
                                                                                {status.icon} {status.text}
                                                                            </span> */}
                                                                        {/* </td> */}
                                                                        <td>{formatDate(row.submission_date)}</td>
                                                                        <td>
                                                                            <button onClick={() => handleViewDetails(row.submission_id, row.user_id)} className="btn-view">
                                                                                👁️ View Details
                                                                            </button>
                                                                        </td>
                                                                      </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                     </table>
                                                </div>
                                                <div className="total-records-info">
                                                    <p>Total Records: <strong>{abcSubmissions.length}</strong></p>
                                                    <div className="completion-summary">
                                                        <span>✅ Complete: {abcSubmissions.filter(s => calculateFormFillingPercentage(s) === 100).length}</span>
                                                        <span>📝 In Progress: {abcSubmissions.filter(s => calculateFormFillingPercentage(s) > 0 && calculateFormFillingPercentage(s) < 100).length}</span>
                                                        <span>❌ Not Started: {abcSubmissions.filter(s => calculateFormFillingPercentage(s) === 0).length}</span>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}

                                {/* Details Modal with Form A, B, C, D Tabs */}
                                {detailsOpen && selectedSubmission && (
                                    <div className="modal-overlay" onClick={() => setDetailsOpen(false)}>
                                        <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
                                            <div className="modal-header">
                                                <h2>📄 Complete Submission Details</h2>
                                                <div className="form-status-summary">
                                                    <span className={selectedSubmission.form_a_submitted ? 'status-success' : 'status-pending'}>
                                                        {selectedSubmission.form_a_submitted ? '✅ Form A' : '⏳ Form A'}
                                                    </span>
                                                    <span className={selectedSubmission.form_b_submitted ? 'status-success' : 'status-pending'}>
                                                        {selectedSubmission.form_b_submitted ? '✅ Form B' : '⏳ Form B'}
                                                    </span>
                                                    <span className={selectedSubmission.form_c_submitted ? 'status-success' : 'status-pending'}>
                                                        {selectedSubmission.form_c_submitted ? '✅ Form C' : '⏳ Form C'}
                                                    </span>
                                                    <span className={selectedFormDData?.form_d_submitted ? 'status-success' : 'status-pending'}>
                                                        {selectedFormDData?.form_d_submitted ? '✅ Form D' : '⏳ Form D'}
                                                    </span>
                                                </div>
                                                <button onClick={() => setDetailsOpen(false)} className="modal-close">×</button>
                                            </div>
                                            
                                            <div className="modal-tabs">
                                                <button className={`tab-btn ${activeTab === 'formA' ? 'active' : ''}`} onClick={() => setActiveTab('formA')}>
                                                    📝 Form A {selectedSubmission.form_a_submitted && '✓'}
                                                </button>
                                                <button className={`tab-btn ${activeTab === 'formB' ? 'active' : ''}`} onClick={() => setActiveTab('formB')}>
                                                    📄 Form B {selectedSubmission.form_b_submitted && '✓'}
                                                </button>
                                                <button className={`tab-btn ${activeTab === 'formC' ? 'active' : ''}`} onClick={() => setActiveTab('formC')}>
                                                    📋 Form C {selectedSubmission.form_c_submitted && '✓'}
                                                </button>
                                                <button className={`tab-btn ${activeTab === 'formD' ? 'active' : ''}`} onClick={() => setActiveTab('formD')}>
                                                    📋 Form D {selectedFormDData?.form_d_submitted && '✓'}
                                                </button>
                                                <button className={`tab-btn ${activeTab === 'files' ? 'active' : ''}`} onClick={() => setActiveTab('files')}>
                                                    📎 Files ({selectedSubmission.files?.length || 0})
                                                </button>
                                            </div>
                                            
                                            <div className="modal-body scrollable">
                                                {activeTab === 'formA' && renderFormADetails(selectedSubmission)}
                                                {activeTab === 'formB' && renderFormBDetails(selectedSubmission)}
                                                {activeTab === 'formC' && renderFormCDetails(selectedSubmission)}
                                                {activeTab === 'formD' && renderFormDDetails(selectedFormDData)}
                                                {activeTab === 'files' && renderFilesSection(selectedSubmission)}
                                            </div>
                                            <div className="modal-footer">
                                                <button onClick={() => setDetailsOpen(false)} className="btn btn-primary">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserTransfer;